import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col, Divider, Select } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useCompanyChildCategory from '../useCompanyChildCategory';
import FormHelper from '../../../../../helpers/FormHelper';

const { Option } = Select;

const CompanyChildCategoryEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const { companyCategories, form, updateInProcess, handleCreateOrUpdate } = useCompanyChildCategory(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const title = isNew
    ? t('CREARE SOTTOCATEGORIE')
    : t('MODIFICA SOTTOCATEGORIE');

  const onClickCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            loyalty_url: '',
            company_category_id: '',
            nego_tov_id: '',
            nego_sov_id: '',
            nego_rov_id: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('Titolo')} name='title'>
                <Input />
              </Form.Item>
            </Col>
            {companyCategories && <Col span={12}>
              <Form.Item
                label={t('Categorie insegne')}
                name='company_category_id'
              >
                <Select placeholder={t('Selezioni opzione')}>
                  <Option value=''>{t('Selezioni opzione')}</Option>
                  {companyCategories.map((i) => (
                    <Option key={i.id} value={i.id}>
                      {i.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>}
            <Col span={8}>
              <Form.Item label={t('NEGO ID (TOV)')} name='nego_tov_id'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (SOV)')} name='nego_sov_id'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (ROV)')} name='nego_rov_id'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Divider />
        <Row gutter={16}>
          <Col>
            <Button
              loading={updateInProcess}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              onClick={onClickCreate}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyChildCategoryEdit;
